import { ChangeDetectorRef, Component, Input, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { UserInvoiceType } from '@shared-features/enums/user-invoice-type.enum';
import { BaseComponent } from '@shared/components/base-component/base.component';
import { debounceTime, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-invoice-type-fees',
  templateUrl: './invoice-type-fees.component.html',
  styleUrls: ['./invoice-type-fees.component.scss'],
})
export class InvoiceTypeFeesComponent extends BaseComponent {
  @Input() form: FormGroup;
  @Input() invoiceType: UserInvoiceType;
  @Input() fixedFees: number;

  invoiceTypeOptions = Object.keys(UserInvoiceType).map((status) => ({
    label:'sharedFeatures.' + status,
    value: UserInvoiceType[status],
    disabled: false,
  }));

  readonly UserInvoiceType = UserInvoiceType;

  constructor(private changeDetectorRef: ChangeDetectorRef) {
    super();
  }

  ngOnInit(): void {
    const isZeroShipmentPrice = this.form?.get('isZeroShipmentPrice');
    if (isZeroShipmentPrice) {
      this.updateInvoiceTypeDisabledOption(isZeroShipmentPrice.value);
      this.isZeroShipmentPriceChange(isZeroShipmentPrice);
    }
  }

  private isZeroShipmentPriceChange(isZeroShipmentPrice) {
    isZeroShipmentPrice.valueChanges
      .pipe(debounceTime(300), takeUntil(this.destroy$))
      .subscribe((value: boolean) => {
        this.updateInvoiceTypeDisabledOption(value);
      });
  }

  private initForm() {
    this.form.addControl('invoiceType', new FormControl(this.invoiceType));
    this.form.addControl('fixedFees', new FormControl(this.fixedFees, Validators.required));
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['form'] && changes['form'].currentValue !== changes['form'].previousValue) {
      this.initForm();
    }
  }

  updateInvoiceTypeDisabledOption(isZeroShipmentPrice: boolean) {
    if (isZeroShipmentPrice) {
      this.form.get('invoiceType').setValue(UserInvoiceType.Saas);
      this.invoiceTypeOptions = [
        {
          label: 'sharedFeatures.Saas',
          value: UserInvoiceType.Saas,
          disabled: false,
        },
        {
          label: 'sharedFeatures.Taas',
          value: UserInvoiceType.Taas,
          disabled: true,
        },
        {
          label: 'sharedFeatures.Both',
          value: UserInvoiceType.Both,
          disabled: true,
        },
      ];
    } else if (!isZeroShipmentPrice) {
      this.invoiceType === UserInvoiceType.Saas
        ? this.form.get('invoiceType').setValue(null)
        : this.form.get('invoiceType').setValue(this.invoiceType || null);
      this.invoiceTypeOptions = [
        {
          label: 'sharedFeatures.Saas',
          value: UserInvoiceType.Saas,
          disabled: true,
        },
        {
          label: 'sharedFeatures.Taas',
          value: UserInvoiceType.Taas,
          disabled: false,
        },
        {
          label: 'sharedFeatures.Both',
          value: UserInvoiceType.Both,
          disabled: false,
        },
      ];
    } else {
      this.form.get('invoiceType').setValue(this.invoiceType || null);
    }
    this.changeDetectorRef.markForCheck();
  }
}
